import { useGetRecipesImportsQuery } from "@/features/recipes/imports/api";
import { Outlet, useParams, Link } from "react-router-dom";
import { HouseholdLayout } from "@/components/layouts/HouseholdLayout";
import { PageHeader } from "@/components/PageHeader";
import { CrudTable } from "@/components/CrudTable";
import { Button, Stack } from "@mui/joy";
import { created, updated } from "@/utils/columns";
import { useEffect, useState } from "react";
import { ImportStatus } from "@/features/recipes/imports/components/ImportStatuses";
import AddIcon from "@mui/icons-material/Add";

export function RecipesImportsPage() {  
  const { householdId } = useParams();  
  const [ hasPending, setHasPending ] = useState(false);
  
  const list =  useGetRecipesImportsQuery({ householdId }, { pollingInterval: hasPending ? 1000 : 0 });

  useEffect(() => {
    setHasPending(list.data?.data.some(item => item.status === 'pending' || item.status === 'processing'));      
  }, [list.data]);

  const options = {
    names: {
      singular: 'recipe import',
      plural: 'recipe imports',
    },

    columns: [     
      { label: 'Status', getter: (row) => <ImportStatus recipeImport={row} />},
      { label: 'Total', getter: (row) => row.total },
      { label: 'Success', getter: (row) => row.success },
      { label: 'Errors', getter: (row) => row.errors },      
      created(),
      updated(),
    ],

    options: {
      searchable: false,            
    },

    actions: {      
      get: ':id',
      extra: [],
    },

    list,
  };

  return (
    <HouseholdLayout>      
      <Stack gap={2} direction="column">
        <PageHeader title="Recipes Imports" subtitle="Import your favorite recipes from the web">              
          <Link to={`./create`}><Button startDecorator={<AddIcon/>}>Create Import</Button></Link>      
        </PageHeader>
        <CrudTable {...options} />
      </Stack>
      <Outlet />
    </HouseholdLayout>
  );
}

